function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1_Mobile",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-496.000000, -353.000000)",
  fill: "#2E2E2E",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M498.375,353 L512.625,353 C513.936676,353 515,354.029745 515,355.3 L515,373.7 C515,374.970255 513.936676,376 512.625,376 L498.375,376 C497.063324,376 496,374.970255 496,373.7 L496,355.3 C496,354.029745 497.063324,353 498.375,353 Z M499.25,355 C498.559644,355 498,355.531662 498,356.1875 L498,372.8125 C498,373.468338 498.559644,374 499.25,374 L511.75,374 C512.440356,374 513,373.468338 513,372.8125 L513,356.1875 C513,355.531662 512.440356,355 511.75,355 L499.25,355 Z M505,372 C504.447715,372 504,371.552285 504,371 C504,370.447715 504.447715,370 505,370 C505.552285,370 506,370.447715 506,371 C506,371.552285 505.552285,372 505,372 Z",
  id: "mobile"
})));

var SvgMobile = function SvgMobile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "23px",
    viewBox: "0 0 19 23",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mobile.32e58127.svg";
export { ForwardRef as ReactComponent };